import React, { useContext, useEffect, useRef, useState } from 'react'
import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useFormContext } from '../Context/Context';
import { useLocation } from 'react-router-dom';
import { useReadOnly } from '../Context/ReadOnlyContext';
import { FinalValuesContext } from '../Context/FinalValuesContext';
import ConvertTitle from './ConvertTitle';
import SpinnerHeaderInput from './Spinner/SpinnerHeaderInput';
import SpinnerControls from './Spinner/SpinnerControls';
import { fillInputValue } from './Spinner/spinnerHelpers';
import SpinnerSubHeaderInput from './Spinner/SpinnerSubHeaderInput';



const Spinner = ({ id, header }) => {

    const { drawerData } = useFormContext();
    const location = useLocation();
    const currentPage = location.pathname;
    const isReadOnly = currentPage.startsWith('/publish') || currentPage.startsWith("/card-form/publish") || currentPage.startsWith("/user/fill-form/");
    const { readOnly } = useReadOnly();
    const { finalSelectValues } = useContext(FinalValuesContext);
    const existingComponentIndex = drawerData.findIndex(component => component.id === id);

    const initialSpinnerValue = drawerData[existingComponentIndex]?.state.spinnerValue || header || "شمارنده";
    const initialInputValue = drawerData[existingComponentIndex]?.state.mainSpinnerInputValue || 0;
    const initialSubValue = drawerData[existingComponentIndex]?.state.subSpinnerValue || "";

    const [spinnerValue, setSpinnerValue] = useState(initialSpinnerValue);
    const [spinnerInputValue, setSpinnerInputValue] = useState(initialInputValue);
    const [subSpinnerValue, setSubSpinnerValue] = useState(initialSubValue);
    const [isSubHeaderVisible, setSubHeaderVisible] = useState(false);
    const [isHeadingFocused, setHeadingFocused] = useState(false);
    const [condition, setCondition] = useState(false);

    const containerRef = useRef(null);

    const titleIndex = finalSelectValues.findIndex(item => item.name === "FieldCondition");
    const title = ConvertTitle({ title: finalSelectValues[titleIndex]?.value });
    const dataIndex = drawerData.findIndex(item => item.title === title);
    const dataCondition = drawerData[dataIndex]?.state.readOnly;

    const handleCondition = () => {
        if (currentPage === '/publish') {
            if (readOnly || dataCondition) {
                setCondition(title === 'Spinner');
            } else {
                setCondition(false);
            }
        } else {
            setCondition(false);
        }
    };

    const handleHeadingFocus = (event) => {
        setHeadingFocused(true);
        event.target.select();
    };

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setSubHeaderVisible(false);
            setHeadingFocused(false);
        } else {
            setSubHeaderVisible(true);
            setHeadingFocused(true);
        }
    };

    const theme = useTheme();
    const isUpXxl = useMediaQuery((theme) => theme.breakpoints.up('xxs'));
    const SubHeadingInputFontSize = isUpXxl ? '14px' : '12px';
    const width = isUpXxl ? '310px' : '90%';
    const HeadingColor = theme.palette.blue[700];

    const handleIncrement = () => {
        if (!condition) setSpinnerInputValue((prev) => Number(prev) + 1);
    };

    const handleDecrement = () => {
        if (!condition) {
            setSpinnerInputValue((prev) => Math.max(Number(prev) - 1, 0));
        }
    };

    useEffect(() => {
        fillInputValue({
            drawerData,
            index: existingComponentIndex,
            values: {
                spinnerValue,
                spinnerInputValue,
                subSpinnerValue
            },
            readOnly
        });
    }, [id, spinnerInputValue, spinnerValue, subSpinnerValue]);

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        handleCondition();
    }, [finalSelectValues, readOnly]);

    return (
        <Grid
            mb={currentPage.startsWith('/build') || currentPage.startsWith('/publish') ? '28px' : '50px'}
            p={drawerData.length > 0 ? (currentPage.startsWith('/build') || currentPage.startsWith('/publish') || currentPage.startsWith('/user/fill-form') ? '12px 10px' : { xs: '12px', md: '24px' }) : '0px'}
            mx={currentPage === '/build' || currentPage === '/publish' ? '4px' : '0px'}
            bgcolor={'white'}
            ref={containerRef}
            border={`2px solid ${isHeadingFocused && drawerData.length > 0 && drawerData[existingComponentIndex] && !isReadOnly ? '#0293e2' : 'transparent'}`}
            onClick={handleClickOutside}
        >
            <Grid className={'HeadingInput'} pb={'14px'}>
                <SpinnerHeaderInput
                    value={spinnerValue}
                    onChange={(e) => setSpinnerValue(e.target.value)}
                    onClick={handleClickOutside}
                    onFocus={isReadOnly ? null : handleHeadingFocus}
                    readOnly={isReadOnly}
                    color={HeadingColor}
                />
            </Grid>

            <SpinnerControls
                value={spinnerInputValue}
                onChange={(e) => setSpinnerInputValue(e.target.value)}
                onDecrement={handleDecrement}
                onIncrement={handleIncrement}
                condition={condition}
                readOnly={isReadOnly}
                width={width}
                headingColor={HeadingColor}
            />

            <Grid display={isReadOnly && subSpinnerValue === '' ? 'none' : 'block'}>
                {isSubHeaderVisible && (
                    <Grid className={'subHeader'} pb={'14px'}>
                        <SpinnerSubHeaderInput
                            value={subSpinnerValue}
                            onChange={(e) => setSubSpinnerValue(e.target.value)}
                            readOnly={isReadOnly || condition}
                            fontSize={SubHeadingInputFontSize}
                        />
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default Spinner;
